import { useEffect, useState } from "react";
import logoPng from "@img/preview-logo.webp";

const LessonThumbnail = ({ videoId }) => {
  const [thumbnail, setThumbnail] = useState("");

  useEffect(() => {
    const fetchThumbnail = async () => {
      try {
        const response = await fetch(
          `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}&width=1280&height=720`
        );
        const data = await response.json();

        // Улучшаем качество превью
        const hdThumbnail = data.thumbnail_url.replace(
          /_[0-9]+\.jpg/,
          "_1280.jpg"
        );
        setThumbnail(hdThumbnail);
      } catch (error) {
        console.error("Ошибка получения превью:", error);
      }
    };

    fetchThumbnail();
  }, [videoId]);

  return (
    <>
      {thumbnail ? (
        <img
          className="lessons-links-item"
          src={thumbnail}
          alt="Превью видео"
        />
      ) : (
        <img
          className="lessons-links-item lessons-links-item--thumbnail "
          src={logoPng}
          alt=""
        />
      )}
    </>
  );
};

export default LessonThumbnail;
